const STORAGE_KEY = "cueshub_acting_tenant";

export type ActingTenant = {
  id: string;
  name: string;
};

export function getActingTenant(): ActingTenant | null {
  if (typeof window === "undefined") return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ActingTenant;
  } catch {
    return null;
  }
}

export function setActingTenant(tenant: ActingTenant | null): void {
  if (typeof window === "undefined") return;
  if (tenant) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tenant));
  } else {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function getActingTenantHeaders(): Record<string, string> {
  const acting = getActingTenant();
  if (!acting) return {};
  return { "X-Acting-Tenant-Id": acting.id };
}
